export const COMMON_PROPS = {
  value: {
    type: [String, Array]
  },
  placeholder: {
    type: String
  },
  clearable: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  reserveKeyword: {
    type: Boolean,
    default: false
  },
  filterable: {
    type: Boolean,
    default: false
  },
  autocompleteAttrs: {
    type: Object,
    default: () => ({})
  },
  options: [Function, Array],
  clearSelectByEmptySearch: {
    type: Boolean,
    default: true
  },
  clearOptionsAfterBlur: {
    type: Boolean,
    default: true
  },
  rowKey: {
    type: String,
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/props/common.js